const addTeam = {
  path: 'addTeam',
  component: resolve => require(['../../../pages/addTeam'], resolve)
}
export default addTeam